<template>
  <div id="blogRoot" ref="blogRoot">
    <component v-for="(content, index) in blogContent"
               :is="content.cardType"
               :key="index"
               :image="content.image"
               :video="content.video"
               :title="content.title"
               :titleSize="content.titleSize"
               :caption="content.caption"
               :mediaOffset="content.mediaOffset"
               :width="content.width"
               :mediaHeight="content.mediaHeight"
               :secondaryCaption="content.secondaryCaption"
               :description="content.description"
               :secondaryDescription="content.secondaryDescription"
               :background="content.backgroundColor"
               :height="windowHeight"
    >
    </component>
    <!--    <Related :related="related"/>-->
    <Subscribe/>
  </div>
</template>

<script>
import Related from "../components/Related";
import SubtitleCard from "../components/blog/SubtitleCard";
import DualMediaCard from "@/components/blog/DualMediaCard";
import TopMediaCard from "@/components/blog/TopMediaCard";
import TopDualMediaCard from "@/components/blog/TopDualMediaCard";
import LeftMediaCard from "@/components/blog/LeftMediaCard";
import Subscribe from "@/components/Subscribe";


export default {
  name: "Blog",
  components: {
    Related, SubtitleCard, TopMediaCard, DualMediaCard, TopDualMediaCard, LeftMediaCard, Subscribe
  },
  created() {
    document.title = this.blog.name + " - OT";
  },
  data() {
    return {
      windowHeight: window.outerHeight,
      windowWidth: window.innerWidth,
      cardType: Image
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    related() {
      return this.blog.related;
    },
    blog() {
      return this.$store.state.blogs[this.$route.params.id];
    },
    blogContent() {
      return this.blog.content;
    }
  },
  methods: {
    onResize() {
      this.windowHeight = window.outerHeight
      this.windowWidth = window.innerWidth
    },
  }
}
</script>
<style lang="scss" src="../styles/blog/blog.scss" scoped/>